import { Bell } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useToast } from "@/hooks/use-toast";

interface Props {
  enabled: boolean;
  trackedCount: number;
  limit: number;
  onChange: (enabled: boolean) => Promise<void> | void;
}

const PriceAlertsCard = ({ enabled, trackedCount, limit, onChange }: Props) => {
  const { toast } = useToast();

  const handle = async (next: boolean) => {
    await onChange(next);
    toast({
      title: next ? "Price alerts on" : "Price alerts off",
      description: next
        ? "We'll email you when a tracked piece changes price."
        : "You'll stop receiving price change emails.",
    });
  };

  return (
    <section className="border border-border bg-card p-5">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-accent/30 flex items-center justify-center shrink-0">
          <Bell className="w-4 h-4 text-foreground" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-foreground">Price alerts</h3>
          <p className="text-sm text-muted-foreground mt-1">
            One email a day when any piece you're tracking changes price, up or
            down. Tracking {trackedCount} of {limit} pieces.
          </p>
        </div>
        <Switch checked={enabled} onCheckedChange={handle} aria-label="Price alerts" />
      </div>
    </section>
  );
};

export default PriceAlertsCard;
